export default __webpack_public_path__ + "svg/calendar/2027/8/octubre.svg?48e14a1a";